<template>
    <Page v-if="isUserInGroup('vcard')" type="gray" :nopadding="true">
        <template v-slot:body>
            <span class="text-900 font-medium mb-4 px-3 justify-content-start text-left
                xl:my-5 lg:my-4 md:my-3
                text-3xl xl:text-6xl lg:text-5xl md:text-4xl
                hidden xl:flex lg:flex md:flex">
                {{ header[this.lang].title }}
            </span>
            <Data  />
        </template>
    </Page>
    <Page v-else type="gray" >
        <template v-slot:body>
            <Be />
        </template>
    </Page>
</template>

<script>
import Connect from         '@/assets/js/Connect'
import Helper from          '@/assets/js/Helper'
import Page from            '@/components/sides/Page.vue' 
import Be from              '@/components/personal/vcard/Be.vue'
import Data from            '@/components/personal/vcard/Data.vue'
import { mapActions } from  'vuex'

export default {
    data() {
        return {
            header: {
                en: { title: 'Virtual cards' },
                ru: { title: 'Виртуальные карты' }
            },
            content: {
                ru: { 
                    btnSupport: 'Поддержка',
                },
                en: { 
                    btnSupport: 'Support',
                }
            }
        }
    },
    components: {
        Page,
        Be,
        Data
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screen_size() { return this.$store.getters.StateScreenSize },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        isUserInGroup (type) { return this.helper.isUserInGroup(type, this.$store.getters.StateGroups) }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)

        try {
            this.SetHeaderTitle(this.header[this.lang].title)
            this.SetHeaderBtnLeftFirst({
                type: 'link',
                link: null,
                icon: 'pi pi-comments',
                class: 'text-xs opacity-0',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                type: 'link',
                link: '/support/',
                label: null,
                icon: 'pi pi-comments',
                iconPos: 'right',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    }
}
</script>